import { FC } from 'react';

import { ContactCategoryPath } from '@/api/address-book/types';
import { Tooltip } from '@/design-system';

import { CATEGORY_VARIANT_TEXT_COLORS, getCategoryBadgeLabel, getCategoryVariant } from '../utils';
import {
  ShrinkWrapper,
  TooltipPath,
  TooltipPathLeaf,
  TruncatedBadge,
} from './category-badge.styled';

interface Props {
  category: ContactCategoryPath;
}

export const CategoryBadge: FC<Props> = ({ category }) => {
  const variant = getCategoryVariant(category.rootName);
  const ancestors = category.path.slice(0, -1);

  return (
    <Tooltip
      key={category.nodeId}
      title={
        <TooltipPath>
          {ancestors.map((node) => `${node.name} > `).join('')}
          <TooltipPathLeaf $color={CATEGORY_VARIANT_TEXT_COLORS[variant]}>
            {category.nodeName}
          </TooltipPathLeaf>
        </TooltipPath>
      }
    >
      <ShrinkWrapper>
        <TruncatedBadge
          label={getCategoryBadgeLabel(category.nodeName)}
          color={variant}
          variant="subtle"
        />
      </ShrinkWrapper>
    </Tooltip>
  );
};
